import React from 'react';
import { Loader2 } from 'lucide-react';

const Button = ({
  children,
  variant = 'primary',
  size,
  disabled = false,
  loading = false,
  icon: Icon,
  iconPosition = 'left',
  additionalIconClasses = '',
  className = '',
  ...props
}) => {
  const variantClasses = {
    primary:   'btn btn-primary',
    secondary: 'btn btn-secondary',
    neutral:   'btn btn-neutral',
    text:      'btn btn-text',
    danger:    'btn btn-danger',
    warning:   'btn btn-warning',
  };

  const sizeClasses = {
    xs: 'px-2 py-1 text-xs',
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-5 py-2 text-sm',
    lg: 'px-8 py-3.5 text-base',
  };

  const classes = [
    variantClasses[variant] || variantClasses.primary,
    size ? sizeClasses[size] : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const iconSpacing = iconPosition === 'left' ? 'mr-2' : 'ml-2';

  return (
    <button className={classes} disabled={disabled || loading} {...props}>
      {loading && iconPosition === 'left' && (
        <Loader2 className={`animate-spin h-4 w-4 ${iconSpacing}`} />
      )}
      {!loading && Icon && iconPosition === 'left' && (
        <Icon className={`w-4 h-4 ${iconSpacing} ${additionalIconClasses}`} />
      )}
      {children}
      {!loading && Icon && iconPosition === 'right' && (
        <Icon className={`w-4 h-4 ${iconSpacing} ${additionalIconClasses}`} />
      )}
      {loading && iconPosition === 'right' && (
        <Loader2 className={`animate-spin h-4 w-4 ${iconSpacing}`} />
      )}
    </button>
  );
};

export default Button;
